<template>
  <div class="outBox">
    <div class="box">
      <div v-loading="loading" element-loading-text="加载数据中"
           element-loading-spinner="el-icon-loading"
           element-loading-background="rgba(0, 0, 0, 0.2)"
           class="mine"></div>
      <div id="main3" class="chart-container"></div>
    </div>
  </div>

</template>

<script>
import * as echarts from 'echarts';


export default {
  name: "echartsThree",
  data(){
    return {
      chart: null,
      loading: false, // 控制加载效果的显示与隐藏
    }
  },
  props: ['dataThree'],
  mounted() {
// 基于准备好的dom，初始化echarts实例
    this.chart = echarts.init(document.getElementById('main3'));
    this.initBar();
    const _this = this;
    this.$nextTick(function () {
      this.$on('resizeThree', function () {
        _this.chart.resize();
      })
    });
  },
  methods:{
    initBar(){
      let option = {
        title: {
          text: '销售额走势图',
          color: '#fff',
          top: 16,
          left: 'center',

          textStyle:{
            fontSize: 18,
            fontWeight: 'bold',
            color: '#fff',
          }
        },
        tooltip: {},
        // legend: {
        //   data: ['销量']
        // },
        xAxis: {
          type: 'category',
          axisLabel: {
            inside: false, // y轴名字是否显示在柱状图里面
            zlevel: 2,
            color: '#fff' // y轴名字颜色
          },
          axisTick: {
            show: true
          },
          axisLine: {
            show: true,
            // 坐标轴轴线相关设置。
            lineStyle: {
              color: '#fff'
            }
          },
          data: this.dataThree.name
        },
        yAxis: [
          {
            type: 'value',
            axisLine: {
              show: true,
              // 坐标轴轴线相关设置。
              lineStyle: {
                color: '#fff'
              }
            },
            axisLabel: {  // 坐标轴上的文字
              color: '#fff',
              margin: 2,
              formatter: function (value, index) {
                if (value >= 10000 && value < 10000000) {
                  value = value / 10000 + "万";
                } else if (value >= 10000000) {
                  value = value / 10000000 + "千万";
                }
                return value;
              }
            },
            axisTick:{ // 坐标轴刻度线
              show:true
            },
            splitLine:{
              show:false // 不显示网格线
            }
          }
        ],
        dataZoom: [
          {
            type: 'slider',
            start: 0,//数据窗口范围的起始百分比0-100。
            end: 10//数据窗口范围的结束百分比0-100。
          },
        ],
        series: [
          {
            name: '销售额',
            // ------------------数据及其样式----------------------------
            // 内柱条的数据
            data: this.dataThree.value, // x轴代表的数据
            type: 'line',
            smooth: true,
            lineStyle: { // 线条样式
              normal: {
                width: 4,
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [ // 颜色渐变
                  {
                    offset: 0,
                    color: 'rgb(0, 255, 255, 0)'
                  },
                  {
                    offset: 0.2,
                    color: 'rgb(0, 255, 255, 10)'
                  },
                  {
                    offset: 0.4,
                    color: 'rgb(0, 200, 200, 80)'
                  },
                  {
                    offset: 0.6,
                    color: 'rgb(0, 200, 200, 80)'
                  },
                  {
                    offset: 0.8,
                    color: 'rgb(0, 255, 255, 10)'
                  },
                  {
                    offset: 1,
                    color: 'rgb(0, 255, 255, 0)'
                  }
                ])
              }
            }

          },

        ],


      };

      // 使用刚指定的配置项和数据显示图表。
      this.chart.setOption(option);
    },
  },
  watch: {
    dataThree(){
      this.initBar()
    }
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  }
}
</script>

<style scoped>
.outBox {
  width: 100%;
  height: 320px;
  /*border: 1px solid #4688ff;*/
}

.box {
  width: 100%;
  height: 320px; /* 与组件中的高度一致 */
  position: relative;
}

.mine {
  width: 100%;
  height: 100%; /* 与组件中的高度一致 */
  position: absolute;
  top: 0;
  left: 0;
}

.chart-container {
  width: 100%;
  height: 100%; /* 与组件中的高度一致 */
}


</style>